import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./discount_type.js";
//#region src/discount_type_helper.ts
var discount_type_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(discountType) {
	switch (discountType) {
		case 1: return "Percent %";
		case 2: return "$ Amount";
	}
}
//#endregion
export { discount_type_helper_exports, name };

//# sourceMappingURL=discount_type_helper.js.map